
function dragscroll(el) {
  el.onmousedown = function (ev) {
    // console.log(el);
    const disX = ev.clientX
    const disY = ev.clientY
    const originalScrollLeft = el.scrollLeft
    const originalScrollTop = el.scrollTop
    const originalScrollBehavior = el.style['scroll-behavior']
    const originalPointerEvents = el.style['pointer-events']
    el.style['scroll-behavior'] = 'auto'
    // 鼠标移动事件是监听的整个document，这样可以使鼠标能够在元素外部移动的时候也能实现拖动
    document.onmousemove = function (ev) {
      ev.preventDefault()
      const distanceX = ev.clientX - disX
      const distanceY = ev.clientY - disY
      el.scrollTo(originalScrollLeft - distanceX, originalScrollTop - distanceY)
      // 由于我们的图片本身有点击效果，所以需要在鼠标拖动的时候将点击事件屏蔽掉
      el.style['pointer-events'] = 'none'
    }
    document.onmouseup = function () {
      document.onmousemove = null
      document.onmouseup = null
      el.style['scroll-behavior'] = originalScrollBehavior
      el.style['pointer-events'] = originalPointerEvents
    }
  }
}
function scroll(el,binding) {
  // console.log(el);
  // el.onmousedown = function (ev) {
  //   // console.log(el);
  // }
  // 定义变量
  let interval;
  let currentIndex = 0;
  const children = el.children;
  console.log(children);
  const length = children.length;
  const delay =  1000;

  // 设置样式
  el.style.overflow = "hidden";
  el.style.position = "relative";

  // 开始轮播
  startCarousel();

  /**
   * 开始轮播
   */
  function startCarousel() {
    console.log(el);
    interval = setInterval(() => {
      // 上一个元素消失
    }, delay);
  }

  /**
   * 停止轮播
   */
  function stopCarousel() {
    clearInterval(interval);
  }

  // 监听鼠标进入和离开事件，停止或开始轮播
  el.addEventListener("mouseenter", stopCarousel, false);
  el.addEventListener("mouseleave", startCarousel, false);
}
export { dragscroll, scroll }